export enum AskDeviceUpdateType {
  Applications = 'APPLICATIONS',
  Basic = 'BASIC',
  BasicRefreshLocation = 'BASIC_REFRESH_LOCATION',
  Capabilities = 'CAPABILITIES',
  Diagnostics = 'DIAGNOSTICS',
  Expert = 'EXPERT',
  General = 'GENERAL',
  Hardware = 'HARDWARE',
  Mdm = 'MDM',
  Security = 'SECURITY',
}

export interface AskDeviceUpdateRequest {
  readonly deviceId: string;
  readonly resource: AskDeviceUpdateType[];
}
